import UrlGeneration from '../urlGeneration';
import EstateLister from '../paginator/estate.js';

function changeSort(event) {
  UrlGeneration.init();
  var sort = this.getAttribute('data-value');
  if (sort !== 'no') {
    UrlGeneration.set('sort', sort);
  } else {
    UrlGeneration.remove('sort');  
  }
  UrlGeneration.update();
  const obEstateLister = new EstateLister();
  obEstateLister.setReplaceMode(true);
  obEstateLister.init(true);
}

function init() {
  const dropdownItems = document.querySelectorAll(`[data-nika-sortirator] > [data-value]`);
  dropdownItems.forEach(function(dropdownItem) {
    dropdownItem.addEventListener('click', changeSort, false);
  });
}

init();
